export default __webpack_public_path__ + "de0869e324680c99efa1250515b4b41c.woff";